





































import {Component, Vue, Watch} from "vue-property-decorator";
import {EmployeeType} from "@/enums/type";
import { debounce } from 'lodash';
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import {PickingListCostParams} from "../../params";
import {PickingListCostStore} from "@/modules/pickinglistcost";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {PickingListCostStatus} from "@/enums/status";

@Component({
    name: "PLCostSearch",
    components: {EnumSelector, EmployeeSelector, MillisecondDatePicker, AInputBarCode}
})
export default class extends Vue {
    EmployeeType = EmployeeType;
    search = new PickingListCostParams();
    PickingListCostStatus = PickingListCostStatus;

    @Watch("search", { immediate: false, deep: true })
    onSearch(val: any, oldVal: any) {
        this.handleChangeSearch(val);
    }

    handleChangeSearch = debounce((val: any) => {
        PickingListCostStore.updatePickingListCostParams({ ...PickingListCostStore.params, ...val });
        PickingListCostStore.listPickingListCost({...PickingListCostStore.params, page: 1});
    }, 500)

    onEnterPickingListCode(evt: any) {
        this.$set(this.search, 'search', evt?.target?.value || undefined);
    }
    onEnterLadingCode(evt: any) {
        this.$set(this.search, 'ladingCode', evt?.target?.value || undefined);
    }
}
